import { ActionPayload } from '../../../types/common/action';
import { postData } from '../../../api/glAxios';
import { getExternalPublishedCount } from '../../../api/glQueries';
import { State } from '../../../types/state';
import { configSiteIdSelector } from '../../../redux/selectors/system/siteid-selector';

// constants
export const EXTERNAL_PUBLISHED_COUNT_LOADED = 'EXTERNAL_PUBLISHED_COUNT_LOADED';

// types
export interface ExternalPublishedCountItem {
    externalPublishingStateName: string;
    publishedListingCount: number;
}

export type ExternalPublishedCountLoadedAction = ActionPayload<ExternalPublishedCountItem[]> & {
    type: typeof EXTERNAL_PUBLISHED_COUNT_LOADED;
};

export const externalPublishedCountLoaded = (payload: ExternalPublishedCountItem[]): ExternalPublishedCountLoadedAction => ({
    type: EXTERNAL_PUBLISHED_COUNT_LOADED,
    payload
});

export const loadExternalPublishedCount = () => (dispatch: Function, getState: () => State) => {
    const siteId = configSiteIdSelector(getState());
    if (siteId !== 'at-comm') {
        dispatch(externalPublishedCountLoaded([]));
        return Promise.resolve();
    }
    const selectedCountry = getState().mapping.selectedCountry;
    if (typeof selectedCountry !== 'string' || !selectedCountry) {
        dispatch(externalPublishedCountLoaded([]));
        return Promise.resolve();
    }
    const regionID: string = selectedCountry;

    return postData(getExternalPublishedCount(regionID))
        .then((response: any) => {
            if (response && response.data && response.data.externalPublishedCount) {
                dispatch(externalPublishedCountLoaded(response.data.externalPublishedCount));
            } else {
                dispatch(externalPublishedCountLoaded([]));
            }
        })
        .catch(() => {
            dispatch(externalPublishedCountLoaded([]));
        });
};